import Vue from 'vue';
import VeeValidate from 'vee-validate';
import { i18n } from '@core/plugins/i18n';
import rules from './rules';

import validationMessagesDE from '@theme/locales/validation/deDE';
import validationMessagesCH from '@theme/locales/validation/deCH';
import validationMessagesAT from '@theme/locales/validation/deAT';

const entries = Object.entries(rules);
for (const [rule, method] of entries) {
  VeeValidate.Validator.extend(rule, method.validate);
}

Vue.use(VeeValidate, {
  i18nRootKey: 'validation',
  i18n,
  inject: false,
  dictionary: {
    'de-AT': validationMessagesAT,
    'de-CH': validationMessagesCH,
    'de-DE': validationMessagesDE
  },
});
